import { useEffect, type ReactNode } from 'react'
import { useAuth } from 'react-oidc-context'
import { setTokenProvider } from '@/api/client'

/**
 * Verbindet die Anmeldung mit dem API-Client.
 *
 * Der API-Client ist bewusst kein React-Hook, damit er auch außerhalb
 * von Komponenten nutzbar bleibt. Diese Komponente reicht ihm deshalb
 * eine Funktion, die das jeweils aktuelle Token liefert.
 *
 * Wichtig ist der access_token, nicht der id_token. Die Weltmaschine
 * prüft die Audience "weltmaschine", und die steht nur im Access Token.
 */
export function ApiTokenBridge({ children }: { readonly children: ReactNode }): ReactNode {
  const auth = useAuth()

  useEffect(() => {
    setTokenProvider(() => auth.user?.access_token)
  }, [auth.user])

  return children
}
